import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IClientModel } from 'src/app/core/models/application.model';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UserService } from 'src/app/core/services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css'],
})
export class NotificationsComponent implements OnInit {
  loggedInUser: IUser;

  constructor(
    private customerService: CustomerService,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private userService: UserService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.loggedInUser = user;
      switch (user.role.name) {
        case 'root':
          this.loadCustomers();
          break;
        case 'customer':
          this.loadSubcustomers();
          this.loadClients(user.customerId, true);
          break;
        case 'client':
          this.loadUsers(user.customerId, user.clientId);
          break;
        default:
          break;
      }

      this.loadNotifications();
    });
  }

  customers: IUser[] = [];

  clients: IClientModel[] = [];
  defaultClients: IClientModel[] = [];

  users: IUser[] = [];

  selectedCustomer: IUser | null = null;
  selectedCustomerName: string | null = 'Select Customer...';
  selectedClient: IClientModel | null = null;
  selectedClientName: string | null = 'Select Client...';
  selectedCustomers: IUser[] = [];
  selectedClients: IClientModel[] = [];
  selectedUsers: IUser[] = [];
  selectedPriority = 'high';

  clientDropdownDisabled = true;
  userDropdownDisabled = true;

  searchText = '';
  searchTextClient = '';
  searchTextUser = '';
  filteredCustomers: IUser[] = [];
  filteredClients: IClientModel[] = [];
  filteredUsers: IUser[] = [];

  isGlobal: false;
  sendPushNotification = false;
  contentType = 'string';

  isUploading = false;
  isSendingNotification = false;
  uploadedFiles: number[] = [];
  allNotifications = null;
  page = 1;
  perPage = 15;
  isLoading = false;
  @ViewChild('notificationsList') notificationsList!: ElementRef;

  get lower() {
    return this.perPage * (this.page - 1) + 1;
  }

  get upper() {
    return Math.min(this.perPage * this.page, this.allNotifications.count);
  }

  loadNotifications() {
    this.isLoading = true;

    this.notificationService
      .getNotifications(this.page, this.perPage)
      .subscribe(
        (res) => {
          this.allNotifications = res;
          this.isLoading = false;

          if (this.allNotifications.results) {
            this.allNotifications.results = this.allNotifications.results.map(
              (notification) => {
                const content =
                  notification.languageContents.find(
                    (lang) => lang.language === 'english'
                  ) || notification.languageContents[0];

                return { ...notification, languageContents: content };
              }
            );
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  loadCustomers() {
    this.customerService.getAll().subscribe((response: IUser[]) => {
      this.customers = response;
      this.filteredCustomers = response;
    });
  }

  allSubustomersAndChild = [];
  getAllSubcustomers(customers) {
    customers.forEach((customer) => {
      if (customer.customers) {
        this.allSubustomersAndChild.push(customer);
        this.getAllSubcustomers(customer.customers);
      } else this.allSubustomersAndChild.push(customer);
    });
  }

  loadSubcustomers() {
    this.customerService
      .get(this.loggedInUser.customerId)
      .subscribe((response) => {
        if (response.customers) {
          this.getAllSubcustomers(response.customers);
          this.filteredCustomers = this.allSubustomersAndChild;
          this.customers = this.allSubustomersAndChild;
        }
      });
  }

  loadClients(customerId: string, isDefault = false) {
    this.customerService
      .getApplications(customerId)
      .subscribe((res: IClientModel[]) => {
        this.clients = res;
        this.filteredClients = res;
        if (isDefault && this.loggedInUser.role.name === 'customer') {
          this.defaultClients = res;
        }
      });
  }

  loadUsers(customerId: string, clientId: string) {
    // this.customerService
    //   .getSubcustomerUsers(customerId, clientId)
    //   .subscribe((res: IUser[]) => {
    //     this.users = res;
    //     this.filteredUsers = res;
    //   });

    this.userService.getByApplicationId(clientId).subscribe((res: IUser[]) => {
      this.users = res;
      this.filteredUsers = res;
    });
  }

  filterCustomers(value: string): IUser[] {
    const filterValue = value.toLowerCase();
    return filterValue
      ? this.customers.filter((customer) =>
          customer.name.toLowerCase().includes(filterValue)
        )
      : null;
  }

  filterClients(value: string): IUser[] {
    const filterValue = value.toLowerCase();
    return filterValue
      ? this.clients.filter((client) =>
          client.name.toLowerCase().includes(filterValue)
        )
      : null;
  }

  filterUsers(value: string): IUser[] {
    const filterValue = value.toLowerCase();
    return filterValue
      ? this.users.filter((user) =>
          user?.name?.toLowerCase().includes(filterValue)
        )
      : null;
  }

  onSearchChange(value: string, type: string) {
    switch (type) {
      case 'customer':
        this.searchText = value;
        this.filteredCustomers = this.filterCustomers(value) || this.customers;
        break;
      case 'client':
        this.searchTextClient = value;
        this.filteredClients = this.filterClients(value) || this.clients;
        break;
      case 'user':
        this.searchTextUser = value;
        this.filteredUsers = this.filterUsers(value) || this.users;
        break;
      default:
        break;
    }
  }

  onCustomerLabelSelect(customer: IUser, event: Event) {
    event.stopPropagation();
    event.preventDefault();
    console.log('customer select fja');
    if (this.selectedCustomer?.id !== customer.id) {
      this.selectedCustomer = customer;
      this.selectedCustomerName = customer.name;
      this.loadClients(customer.id);
    } else {
      this.selectedCustomer = null;
      this.selectedClient = null;
      this.selectedCustomerName = 'Select Customer...';
      if (this.loggedInUser.role.name === 'customer') {
        console.log(this.defaultClients);
        this.clients = this.defaultClients;
        this.filteredClients = this.defaultClients;
      }
    }

    this.selectedClient = null;
    this.selectedClientName = 'Select Client...';

    // this.selectedClients = [];
    // this.selectedUsers = [];
    this.clientDropdownDisabled = false;
    this.userDropdownDisabled = true;
    // Logic to filter clients based on selected customer ID
  }

  onCustomerCheckboxSelect(customer: IUser) {
    if (!this.selectedCustomers.includes(customer)) {
      this.selectedCustomers.push(customer);
    } else {
      const index = this.selectedCustomers.indexOf(customer);
      this.selectedCustomers.splice(index, 1);
    }
  }

  onClientCheckboxSelect(client: IClientModel) {
    if (!this.selectedClients.includes(client)) {
      this.selectedClients.push(client);
    } else {
      const index = this.selectedClients.indexOf(client);
      this.selectedClients.splice(index, 1);
    }
  }

  onClientSelect(client: IClientModel, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.selectedClient?.id !== client.id) {
      this.selectedClient = client;
      this.selectedClientName = client.name;
      this.loadUsers(this.selectedCustomer?.id, client.id);
    } else {
      this.selectedClient = null;
      this.selectedClient = null;
      this.selectedClientName = 'Select Client...';
    }

    // this.selectedUsers = [];
    this.userDropdownDisabled = false;
    // Logic to filter users based on selected client ID
  }

  onUserSelect(user: IUser) {
    if (!this.selectedUsers.includes(user)) {
      this.selectedUsers.push(user);
    } else {
      const index = this.selectedUsers.indexOf(user);
      this.selectedUsers.splice(index, 1);
    }
  }

  isDisabled(type: string): boolean {
    switch (type) {
      case 'customer':
        return (
          this.selectedClients.length !== 0 ||
          this.selectedUsers.length !== 0 ||
          this.isGlobal
        );
      case 'client':
        return (
          this.selectedCustomers.length !== 0 ||
          this.selectedUsers.length !== 0 ||
          this.isGlobal
        );
      case 'user':
        return (
          this.selectedClients.length !== 0 ||
          this.selectedCustomers.length !== 0 ||
          this.isGlobal
        );
      default:
        return false;
    }
  }

  handleChangeGlobal() {
    if (this.isGlobal) {
      this.selectedCustomers = [];
      this.selectedClients = [];
      this.selectedUsers = [];
      this.selectedCustomerName = 'Select Customer...';
      this.selectedClientName = 'Select Client...';
    }
  }

  inputDate: string = '';

  validateAndConvertDate() {
    const dateRegex = /^\d{2}\.\d{2}\.\d{4}\.?$/; // Regular expression for dd.mm.yyyy format with an optional dot at the end

    console.log(this.inputDate);
    if (dateRegex.test(this.inputDate)) {
      const [day, month, year] = this.inputDate.split('.'); // Split the input date

      // Create a new Date object using the split values (subtract 1 from month because it's zero-indexed)
      const formattedDate = new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day)
      );

      if (!isNaN(formattedDate.getTime())) {
        // Check if it's a valid date
        const isoFormattedDate = formattedDate.toISOString().split('T')[0]; // Get ISO format (yyyy-mm-dd)
        console.log(isoFormattedDate); // Output the ISO formatted date (you can use it as needed)
      } else {
        console.error('Invalid date');
      }
    } else {
      console.error('Invalid date format. Please enter in dd.mm.yyyy format');
    }
  }

  languages: any[] = [
    {
      language: 'english',
      headLine: '',
      shortContent: '',
      content: '',
    },
  ];
  defaultLang: any = {
    language: 'english',
    headLine: '',
    shortContent: '',
    content: '',
  };

  getAvailableLanguages(index: number): string[] {
    const selectedLanguages = this.languages.map((lang, idx) => {
      if (idx !== index) {
        return lang.language;
      }
      return null;
    });

    return [
      'english',
      'spanish',
      'german',
      'french',
      'italian',
      'hungarian',
      'catalan',
      'portuguese',
    ].filter((lang) => !selectedLanguages.includes(lang));
  }

  addLanguage() {
    if (this.isDisabledAddLanguage()) {
      return this.translate.get('errors.pleaseSelectLanguageFirst').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    this.languages.push({
      language: '',
      headLine: '',
      shortContent: '',
      content: '',
    });
  }

  isDisabledAddLanguage() {
    const languages = this.languages.filter(
      (lang) => lang.language !== 'english'
    );

    const hasEmptyValues = languages.some((language) => !language.language);

    return hasEmptyValues;
  }

  removeLanguage(index: number) {
    this.languages.splice(index, 1);
  }

  showCustomers = false;
  showClients = false;
  showUsers = false;

  openDropdown(type) {
    switch (type) {
      case 'customer':
        this.showCustomers = !this.showCustomers;
        this.searchText = '';
        this.filteredCustomers = this.customers;
        break;
      case 'client':
        this.showClients = !this.showClients;
        this.searchTextClient = '';
        this.filteredClients = this.clients;
        break;
      case 'user':
        this.showUsers = !this.showUsers;
        this.searchTextUser = '';
        this.filteredUsers = this.users;
        break;
      default:
        break;
    }
  }

  getFormatedNames(type) {
    switch (type) {
      case 'customer':
        return this.selectedCustomers.map((user) => user.name).join(', ');
      case 'client':
        return this.selectedClients.map((user) => user.name).join(', ');
      case 'user':
        return this.selectedUsers.map((user) => user.name).join(', ');
      default:
        return;
    }
  }

  handleSendNotification(form: NgForm) {
    const { sendPushNotification, validUntil, priority, contentType } =
      form.form.value;

    console.log(this.languages);
    // languageContent i target

    // lang mora min 1 length
    // if (!this.languages.length) {
    //   return this.toastr.error('You need to select at least one language');
    // }

    if (!this.languages.find((lang) => lang.language === 'english')) {
      return this.translate.get('errors.selectDefaultEnglishLanguage').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    const hasEmptyValues = this.languages.some(
      (language) =>
        !language.language || !language.headLine || !language.content
    );

    if (hasEmptyValues) {
      return this.toastr.error(
        'Some language have empty values for language, headLine, or content.'
      );
    }

    const languageContents = this.languages.map(({ fileData, ...rest }) => {
      const filteredRest = Object.fromEntries(
        Object.entries(rest).filter(([key, value]) => value !== '')
      );
      return filteredRest;
    });

    if (
      !this.isGlobal &&
      !this.selectedCustomers.length &&
      !this.selectedClients.length &&
      !this.selectedUsers.length
    ) {
      this.toastr.error(
        'You have to select who you want to send the notification to'
      );
    }

    let target;
    if (this.isGlobal) {
      target = { global: true };
    } else {
      if (this.selectedCustomers.length) {
        target = {
          customer: {
            customerIds: this.selectedCustomers.map((customer) => customer.id),
            isSubCustomers: form.form.value['isSubCustomers'] || false,
            onlyAdmins: form.form.value['onlyAdmins'] || undefined,
          },
        };
      } else if (this.selectedClients.length) {
        target = {
          client: {
            clientIds: this.selectedClients.map((client) => client.id),
            onlyAdmins: form.form.value['onlyAdmins'] || undefined,
          },
        };
      } else if (this.selectedUsers.length) {
        target = {
          user: {
            userIds: this.selectedUsers.map((user) => user.id),
          },
        };
      }
    }

    let isoDate = null;
    if (validUntil) {
      // Split the given date into day, month, and year
      const [day, month, year] = validUntil.split('.');

      // Create a new Date object using the components in the desired format (year, month - 1, day)
      isoDate = new Date(`${year}-${month}-${day}`).toISOString().split('T')[0];
    }

    const body = {
      sendPushNotification,
      validUntil: isoDate || undefined,
      priority,
      contentType,
      languageContents,
      target,
    };

    console.log(body);
    this.isSendingNotification = true;

    this.notificationService.sendNotification(body).subscribe(
      (res) => {
        this.isSendingNotification = false;
        this.toastr.success('Notification has been sent.');
        this.languages = [
          {
            language: 'english',
            headLine: '',
            shortContent: '',
            content: '',
          },
        ];
        this.selectedCustomers = [];
        this.selectedClients = [];
        this.selectedUsers = [];
      },
      (err) => {
        this.isSendingNotification = false;
      }
    );
  }

  onFileSelected(event: any, index): void {
    const file = event.target.files[0];

    this.languages[index].fileData = file;

    const formData: FormData = new FormData();
    formData.append('content', file);
    formData.append('type', this.contentType);

    this.isUploading = true;

    this.notificationService.uploadFile(formData).subscribe(
      (res) => {
        this.languages[index].content = res.path;
        this.isUploading = false;
        this.uploadedFiles.push(index);
      },
      (err) => {
        this.isUploading = false;
      }
    );
  }

  canSelectClient() {
    switch (this.loggedInUser.role.name) {
      case 'root':
        return !!this.selectedCustomer;
      case 'customer':
        return true;
      default:
        return true;
    }
  }

  canSelectUsers() {
    switch (this.loggedInUser.role.name) {
      case 'root':
        return !!this.selectedClient;
      case 'customer':
        return !!this.selectedClient;
      default:
        return true;
    }
  }

  jumpToPage(event: any) {
    this.page = event;

    this.loadNotifications();

    if (this.notificationsList && this.notificationsList.nativeElement) {
      // this.notificationsList.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const yOffset =
        this.notificationsList.nativeElement.getBoundingClientRect().top +
        window.scrollY -
        70;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
  }
}
